import { useEffect } from 'react';
import { DEFAULT_OG_IMAGE, SEOConfig, SITE_NAME } from '../utils/seo';

interface SEOHeadProps {
  config: SEOConfig;
}

export default function SEOHead({ config }: SEOHeadProps) {
  useEffect(() => {
    document.title = config.title;

    const updateMetaTag = (property: string, content: string, isProperty = false) => {
      const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
      let element = document.querySelector(selector);

      if (!element) {
        element = document.createElement('meta');
        if (isProperty) {
          element.setAttribute('property', property);
        } else {
          element.setAttribute('name', property);
        }
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    const updateLinkTag = (rel: string, href: string) => {
      let element = document.querySelector(`link[rel="${rel}"]`);

      if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
      }

      element.setAttribute('href', href);
    };

    updateMetaTag('description', config.description);

    if (config.keywords) {
      updateMetaTag('keywords', config.keywords);
    }

    if (config.canonical) {
      updateLinkTag('canonical', config.canonical);
    }

    updateMetaTag('robots', config.noindex ? 'noindex,nofollow' : 'index,follow');

    updateMetaTag('og:title', config.title, true);
    updateMetaTag('og:description', config.description, true);
    updateMetaTag('og:type', config.ogType || 'website', true);
    updateMetaTag('og:site_name', SITE_NAME, true);
    updateMetaTag('og:locale', 'es_ES', true);

    if (config.canonical) {
      updateMetaTag('og:url', config.canonical, true);
    }

    updateMetaTag('og:image', config.ogImage || DEFAULT_OG_IMAGE, true);

    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', config.title);
    updateMetaTag('twitter:description', config.description);
    updateMetaTag('twitter:image', config.ogImage || DEFAULT_OG_IMAGE);
  }, [config]);

  return null;
}
